<div [formGroup]="form">
    <div class="row">
        <div class="col-sm-2 bolded">{{'CampDetails.DayVariantName' | translate}}</div>
        <div class="col-sm-4">
            <input hznTestId="day-variant-name" formControlName="name" class="form-control" maxlength="160" />
        </div>
        <div class="col-sm-4">
      
        </div>
        <div class="col-sm-2">
            <button class="btn btn-success btn-action pull-right" [disabled]="!isFormValid()" type="button" bcClick hznTestId="day-variant-save" (clicked)="save()">{{'General.Save' | translate}}</button>
            <button class="btn btn-danger btn-action pull-right mr-1" type="button" bcClick (clicked)="cancel()">{{'General.Cancel' | translate}}</button>

        </div>
    </div>
    <div class="row  mt-2">

   
        <div class="col-sm-2 bolded">{{'CampDetails.Order' | translate}}</div>
        <div class="col-sm-4">
            <input class="form-control" hznTestId="day-variant-order" formControlName="order" type="number"  min="0" step="1" max="9999" numbersOnly="9999"/>
        </div>
        <div class="col-sm-2 bolded">{{'CampDetails.VisibleInConnect' | translate}}</div>
        <div class="col-sm-4">
            <ui-switch hznTestId="day-variant-visible" [checked]="form.controls.isVisibleToMembers.value" (change)="onVisibleChange($event)" class="switch" size="small"
                color="#346ABC" switchColor="white"></ui-switch>
                
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-sm-2 bolded">{{'CampDetails.DayVarianDates' | translate}}</div>

        <div class="col-sm-10">

            <app-dates-selector hznTestId="day-variant-dates" name="daysDates" [allowedDates]="form.controls.allDays.value" formControlName="daysDates" [readonly]="false" [isRequired]="true"></app-dates-selector>
        </div>

    </div>

    <hr>
</div>